import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import { prop } from 'styled-tools';
import Papa from 'papaparse';
import { withAuth } from '../../../context/auth';
import { withLoading } from '../../../context/loading';
import { getCompetitionClothingTemplates, getCompetitionUsers, getPreRegisterCompetitionUsers } from '../../../api/info';
import { dresses } from '../../../constants/dresses';

const Container = styled(Flex)`
  background: url(${prop('background')}) no-repeat center;
  background-size: 100% 100%;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  height: 100%;
  padding: 10px;
`;

class InfoPage extends React.Component {

  state = {
    pdfDownloadedCompetitionUsers: 0,
    preRegisterCompetitionUsers: 0,
    primaryClothingTemplates: [],
    secondaryClothingTemplates: [],
    tertiaryClothingTemplates: [],
  }

  componentDidMount() {
    this.setState({ clothingTemplates: [] });
    this._getPreRegisterCompetitionUsers();
    this._getPDFDownlaodedCompetitionUsers();
    this._getCompetitionClothingTemplates('primary');
    this._getCompetitionClothingTemplates('secondary');
    this._getCompetitionClothingTemplates('tertiary');
  }

  formatUserData = (users) => {
    const userList = users.map(data => {
      const user = {};
      user.email = data.username;
      user.name = data.name;
      user.phone = data.phone;
      user.group = data.group;
      user.school = data.school;
      return user;
    })
    return userList;
  }

  _getPreRegisterCompetitionUsers = () => {
    const { auth, setAuth } = this.props;
    return getPreRegisterCompetitionUsers(null, auth, setAuth).then(obj => {
      if (obj && obj.status === 200 && !obj.error) {
        this.setState({ preRegisterCompetitionUsers: this.formatUserData(obj.data) });
      }
    })
  }

  _getPDFDownlaodedCompetitionUsers = () => {
    const { auth, setAuth } = this.props;
    const params = {
      competition: '38401590-9506-4a0b-8870-5e2d48383cb6'
    }
    return getCompetitionUsers(params, auth, setAuth).then(obj => {
      if (obj && obj.status === 200 && !obj.error) {
        this.setState({ pdfDownloadedCompetitionUsers: this.formatUserData(obj.data) });
      }
    })
  }

  _getCompetitionClothingTemplates = (group) => {
    const { auth, setAuth } = this.props;
    const params = {
      competition: '38401590-9506-4a0b-8870-5e2d48383cb6',
      'competition_user[null]': true,
      group: group,
    }
    return getCompetitionClothingTemplates(params, auth, setAuth).then(obj => {
      if (obj && obj.status === 200 && !obj.error) {
        const clothingTemplates = [];
        for (let i = 0; i < dresses.length; i++) {
          clothingTemplates[i] = dresses[i];
        }
        obj.data.forEach(clothingTemplate => {
          const clothingPresetId = clothingTemplate.clothing_preset;
          const dressIndex = clothingTemplates.findIndex(dress => dress.id === clothingPresetId);
          const dress = { ...clothingTemplates[dressIndex]};
          const dressCount = dress.count;
          if (!dressCount) {
            dress.count = 1;
          } else {
            dress.count += 1;
          }
          clothingTemplates[dressIndex] = dress;
        })
        if (group === 'primary') {
          this.setState({ primaryClothingTemplates: clothingTemplates });
        } else if (group === 'secondary') {
          this.setState({ secondaryClothingTemplates: clothingTemplates });
        } else if (group === 'tertiary') {
          this.setState({ tertiaryClothingTemplates: clothingTemplates });
        }
      }
    })
  }

  downloadCsv = (data, fileName) => {
    var csvData = new Blob([data], {type: 'text/csv;charset=utf-8;'});
    var csvURL =  null;
    if (navigator.msSaveBlob){
        csvURL = navigator.msSaveBlob(csvData, `${fileName}.csv`);
    } else {
        csvURL = window.URL.createObjectURL(csvData);
    }
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', `${fileName}.csv`);
    tempLink.click();
  }

  exportCompetitionUser = (userList, fileName) => {
    var csv = Papa.unparse(userList);
    this.downloadCsv(csv, fileName);
  }
  
  render() {
    const { preRegisterCompetitionUsers, pdfDownloadedCompetitionUsers, primaryClothingTemplates, secondaryClothingTemplates, tertiaryClothingTemplates } = this.state;
    return (
      <Container>
        <Flex mt="1rem">
          Submitted Form (JotForm): {preRegisterCompetitionUsers.length}
          <button type="button" onClick={()=>this.exportCompetitionUser(preRegisterCompetitionUsers, 'jot_form_submissions')} style={{ marginLeft: 10, width: 100 }}>Export Data</button>
        </Flex>
        <Flex mt="1rem">
          Submitted Form (PDF Template): {pdfDownloadedCompetitionUsers.length}
          <button type="button" onClick={()=>this.exportCompetitionUser(pdfDownloadedCompetitionUsers, 'pdf_download_submissions')} style={{ marginLeft: 10, width: 100 }}>Export Data</button>
        </Flex>
        <Flex mt="1rem" flexDirection="column">
          <Flex>
            Remaining Templates:
          </Flex>
          <Flex mt="1rem" flexDirection="column">
            <Flex my="1rem">Primary:</Flex>
            {primaryClothingTemplates.map((clothingTemplate, index) => <Flex key={index}>{clothingTemplate.name}: {clothingTemplate.count}</Flex>)}
            <Flex my="1rem">Secondary:</Flex>
            {secondaryClothingTemplates.map((clothingTemplate, index) => <Flex key={index}>{clothingTemplate.name}: {clothingTemplate.count}</Flex>)}
            <Flex my="1rem">Tertiary:</Flex>
            {tertiaryClothingTemplates.map((clothingTemplate, index) => <Flex key={index}>{clothingTemplate.name}: {clothingTemplate.count}</Flex>)}
          </Flex>
        </Flex>
      </Container>
    );
  }
}

InfoPage.propTypes = {
  auth: PropTypes.object,
  setAuth: PropTypes.func,
};

InfoPage.defaultProps = {
  auth: null,
  setAuth: () => {},
};

export default withAuth(withLoading(InfoPage));
